import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createAdminApiClient } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const AdminLogin = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [credentials, setCredentials] = useState({
        username: "admin",
        password: ""
    });
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            const adminApi = createAdminApiClient(credentials.username, credentials.password);
            await adminApi.login();
            
            // Store credentials in session storage
            sessionStorage.setItem('adminCredentials', JSON.stringify(credentials));
            
            toast.success("Login successful");
            navigate('/admin');
        } catch (err) {
            console.error("Login failed:", err);
            toast.error("Invalid credentials. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6">
            <Card className="w-full max-w-md bg-card border border-border rounded-none">
                <CardContent className="p-8">
                    <div className="text-center mb-8">
                        <div className="w-16 h-16 bg-primary/10 flex items-center justify-center mx-auto mb-4">
                            <Lock className="h-8 w-8 text-primary" />
                        </div>
                        <h1 className="font-heading font-black text-2xl tracking-tight mb-2">Admin Login</h1>
                        <p className="text-muted-foreground text-sm">Dryice Marketplace CMS</p>
                    </div>
                    
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="space-y-2">
                            <Label htmlFor="username" className="font-mono text-xs uppercase tracking-wider">
                                Username
                            </Label>
                            <Input
                                id="username"
                                value={credentials.username}
                                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                                className="rounded-none bg-input border-transparent focus:border-primary h-12"
                                data-testid="admin-username"
                            />
                        </div>
                        
                        <div className="space-y-2">
                            <Label htmlFor="password" className="font-mono text-xs uppercase tracking-wider">
                                Password
                            </Label>
                            <Input
                                id="password"
                                type="password"
                                value={credentials.password}
                                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                                required
                                className="rounded-none bg-input border-transparent focus:border-primary h-12"
                                placeholder="Enter admin password"
                                data-testid="admin-password"
                            />
                        </div>
                        
                        <Button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-none uppercase font-bold tracking-wider py-6"
                            data-testid="admin-login-btn"
                        >
                            {loading ? "Logging in..." : "Login"}
                        </Button>
                    </form>
                    
                    <p className="text-center text-muted-foreground text-xs mt-6">
                        Default password: dryicebulls2024
                    </p>
                </CardContent>
            </Card>
        </div>
    );
};

export default AdminLogin;
